module.exports = __webpack_public_path__ + "static/media/borrowers-stock.8779e02a.png";